export interface SafeMarkdownLink {
  external: boolean;
  href: string;
}

const absoluteProtocol = /^[a-zA-Z][a-zA-Z\d+.-]*:/;

function containsControlCharacter(value: string) {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    if (code <= 31 || code === 127) return true;
  }
  return false;
}

export function safeMarkdownLink(value: string): SafeMarkdownLink | null {
  const href = value.trim();
  if (!href || containsControlCharacter(href)) return null;
  if (href.startsWith("#") || href.startsWith("/") || href.startsWith("./") || href.startsWith("../")) {
    return { external: false, href };
  }
  if (!absoluteProtocol.test(href) && !href.startsWith("//")) {
    return { external: false, href };
  }
  try {
    const url = new URL(href, "https://merry.invalid");
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;
    return { external: url.origin !== "https://merry.invalid", href: url.href };
  } catch {
    return null;
  }
}
